const config = {
  hamBtnId: '#hamburgerMenu',
  navId: '#navigation',
};

const hamConfig = {
  hamBtn: document.querySelector(config.hamBtnId),
  nav: document.querySelector(config.navId),
  body: document.body,
};

hamConfig.nav.dataset.isOpen = false;
hamConfig.hamBtn.dataset.isOpen = false;

hamConfig.hamBtn.addEventListener('click', () => {
  const open = hamConfig.nav.dataset.isOpen;
  if (open === 'false') {
    hamConfig.nav.style.display = 'flex';
    hamConfig.hamBtn.dataset.isOpen = true;
    hamConfig.body.classList.add('is-open');
    hamConfig.body.classList.remove('is-close');
    hamConfig.nav.classList.remove('is-close');
    hamConfig.nav.classList.add('is-open');
    hamConfig.nav.classList.add('is-open-animation');
    if (hamConfig.nav.classList.contains('is-open-animation')) {
      hamConfig.nav.addEventListener('animationend', () => {
        hamConfig.nav.dataset.isOpen = true;
        hamConfig.nav.style.display = 'flex';
        hamConfig.nav.classList.remove('is-open-animation');
      });
    }
  } else if (open === 'true') {
    hamConfig.hamBtn.dataset.isOpen = false;
    hamConfig.body.classList.remove('is-open');
    hamConfig.body.classList.add('is-close');
    hamConfig.nav.classList.add('is-close');
    hamConfig.nav.classList.remove('is-open');
    hamConfig.nav.classList.add('is-close-animation');
    if (hamConfig.nav.classList.contains('is-close-animation')) {
      hamConfig.nav.addEventListener('animationend', () => {
        hamConfig.nav.dataset.isOpen = false;
        hamConfig.nav.style.display = 'none';
        hamConfig.nav.classList.remove('is-close-animation');
      });
    }
  } else {
    return false;
  }
});

document.querySelectorAll('.header--food .nav__globalMenu a').forEach((link) => {
  link.addEventListener('click', () => {
    if (hamConfig.hamBtn.dataset.isOpen === 'true') {
      hamConfig.hamBtn.click();
    }
  });
});
